
import Promise from "plugins/bluebird"
import { EventEmitter } from "events"

import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
import DataRetriever from "app/data_retriever"

import Google_PageView from "app/tracking/google/page_view"
import YahooGemini_Conversion from "app/tracking/yahoo_gemini/conversions"
const {SendSpaciousEnquiry, SendPhoneEnquiry} = YahooGemini_Conversion
import Goals_track from "app/tracking/goals/track"
import FacebookPixel_Event from "app/tracking/facebook-pixel/event"

import Contact_Shared from "concepts/listings/contact/shared/index"

import {
  get_one as get_one_listing,
  ResultTypeEnums as GetOneListingResultTypes,
} from "app/resources/listings/get_one/index"

import {
  captureMessage,
} from "app/error_reporting"


const ee = new EventEmitter()

const tracking_distinct_id = DataRetriever.get("tracking-distinct-id")

ee.on("modal_show", () => {
  // do nothing as modal AB test is over
})

ee.on("submit_click", () => {
  Google_PageView.track(
    [
      "/fake-path",
      "/apps/spacious-web-app",
      `/pages/${Contact_Shared.getPageElementForTracking()}`,
      "/components/contact-lister-modal/contact-by-spacious-button",
      "/events/click",
    ].join("")
  )
  SendSpaciousEnquiry.track()
})

ee.on("successful_submit", (listing_id: string, is_rental: any, is_commercial: any) => {
  get_one_listing({
    id: listing_id,
  })
  .then(({result_type, data: listing_data}) => {
    switch (result_type) {
      case GetOneListingResultTypes.SUCCESS: {
        if (listing_data == null) { return }

        if (listing_data.is_for_serviced_office) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.SERVICED_OFFICE,
          )
          FacebookPixel_Event.trackCustomEvent("SOCWS-EmailEnquiry")
          return
        }
        if (listing_data.is_for_coworking_space) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.COWORKING_SPACE,
          )
          FacebookPixel_Event.trackCustomEvent("SOCWS-EmailEnquiry")
          return
        }
        if (listing_data.is_for_business_center) {
          // Fallback for other business center types
          // If there are other new types in the future
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.BUSINESS_CENTER,
          )
          FacebookPixel_Event.trackCustomEvent("SOCWS-EmailEnquiry")
          return
        }
        if (listing_data.for_overseas_marketing_only) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.OVERSEAS,
          )
          FacebookPixel_Event.trackCustomEvent("OP-EmailEnquiry")
          return
        }
        if (listing_data.is_for_serviced_apartment) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.SERVICED_APARTMENT,
          )
          FacebookPixel_Event.trackCustomEvent("SACLS-EmailEnquiry")
          return
        }
        if (listing_data.is_for_coliving_space) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.COLIVING_SPACE,
          )
          FacebookPixel_Event.trackCustomEvent("SACLS-EmailEnquiry")
          return
        }

        if (listing_data.is_rental && !listing_data.is_commercial_listing) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.RESIDENTIAL_RENTAL,
          )
          FacebookPixel_Event.trackCustomEvent("RRRS-EmailEnquiry")
          return
        }
        if (!listing_data.is_rental && !listing_data.is_commercial_listing) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.RESIDENTIAL_SALE,
          )
          FacebookPixel_Event.trackCustomEvent("RRRS-EmailEnquiry")
          return
        }

        if (listing_data.is_rental && listing_data.is_commercial_listing) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.COMMERCIAL_RENTAL,
          )
          FacebookPixel_Event.trackCustomEvent("CRCS-EmailEnquiry")
          return
        }
        if (!listing_data.is_rental && listing_data.is_commercial_listing) {
          Goals_track.ListingContactByEmail.track(
            Goals_track.ListingContactByEmail.PropertyTypeLabels.COMMERCIAL_SALE,
          )
          FacebookPixel_Event.trackCustomEvent("CRCS-EmailEnquiry")
          return
        }

        break
      }
      default: {
        captureMessage(
          `unexpected/unhandled result_type in "successful_submit" handler: <${result_type}>`,
          {
            source_file_path:
              "app/assets/javascripts/concepts/listings/contact/request/box/components/tracking/index.es6",
          }
        )
      }
    }
  })

})

ee.on("show_phone_btn_click", (listing_id) => {
  Google_PageView.track(
    [
      "/fake-path",
      "/apps/spacious-web-app",
      `/pages/${Contact_Shared.getPageElementForTracking()}`,
      "/components/contact-lister-modal/contact-by-phone-button",
      "/events/click",
    ].join(""),
  )
  SendPhoneEnquiry.track()

  Goals_track.ListingContactByPhone.track()

  Promise.resolve(
    import(
      "plugins/js-routes"
    )
  )
  .then((Routes) => {
    return q_ajax_3({
      url:      Routes.api_web_app_listing_tracking_events_with_type_contact_by_phone_index_path(),
      method:   "POST",
      dataType: "json",
      data:     {
        listing_id,
        tracking_distinct_id,
      },
    })
  })
  .done()
})

ee.on("phone_btn_success_submit", (listing_id: string, is_rental: any, is_commercial: any) => {
  get_one_listing({
    id: listing_id,
  })
  .then(({result_type, data: listing_data}) => {
    switch (result_type) {
      case GetOneListingResultTypes.SUCCESS: {
        if (listing_data == null) { return }

        if (listing_data.is_for_serviced_office) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.SERVICED_OFFICE,
          )
          return
        }
        if (listing_data.is_for_coworking_space) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.COWORKING_SPACE,
          )
          return
        }
        if (listing_data.is_for_business_center) {
          // Fallback for other business center types
          // If there are other new types in the future
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.BUSINESS_CENTER,
          )
          return
        }
        if (listing_data.for_overseas_marketing_only) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.OVERSEAS,
          )
          return
        }
        if (listing_data.is_for_serviced_apartment) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.SERVICED_APARTMENT,
          )
          return
        }
        if (listing_data.is_for_coliving_space) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.COLIVING_SPACE,
          )
          return
        }

        if (listing_data.is_rental && !listing_data.is_commercial_listing) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.RESIDENTIAL_RENTAL,
          )
          return
        }
        if (!listing_data.is_rental && !listing_data.is_commercial_listing) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.RESIDENTIAL_SALE,
          )
          return
        }

        if (listing_data.is_rental && listing_data.is_commercial_listing) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.COMMERCIAL_RENTAL,
          )
          return
        }
        if (!listing_data.is_rental && listing_data.is_commercial_listing) {
          Goals_track.ListingContactSuccessByPhone.track(
            Goals_track.ListingContactSuccessByPhone.PropertyTypeLabels.COMMERCIAL_SALE,
          )
          return
        }

        break
      }
      default: {
        captureMessage(
          `unexpected/unhandled result_type in "successful_submit" handler: <${result_type}>`,
          {
            source_file_path:
              "app/assets/javascripts/concepts/listings/contact/request/box/components/tracking/index.es6",
          }
        )
      }
    }
  })

  Promise.resolve(
    import(
      "plugins/js-routes"
    )
  )
  .then((Routes) => {
    return q_ajax_3({
      url:      Routes.api_web_app_listing_tracking_events_with_type_contact_by_phone_success_index_path(),
      method:   "POST",
      dataType: "json",
      data:     {
        listing_id,
        tracking_distinct_id,
      },
    })
  })
})

export default ee
